<template>
  <div class="recommendation-item">
    <div
      v-for="item in recommendation.contents" :key="item.id"
      class="item">
      <div class="recommendation-image" v-if="item.image">
        <img :src="item.image.url" alt="*"/>
      </div>

      <div class="recommendation-content">
        <div class="recommendation-title">{{item.title}}</div>

        <div class="recommendation-text">{{item.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RecommendationItem',

    props: ['recommendation'],

    data() {
      return {};
    },

    computed: {},

    methods: {},
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .recommendation-item {
    text-align: center;
    color: $white;
    background-color: $primary;

    .recommendation-image {
      img {
        width: 100%;
      }
    }

    .recommendation-content {
      padding: 100px 20px;

      .recommendation-title {
        margin: 0 0 30px;
        font-weight: bold;
      }

      .recommendation-text {
      }
    }
  }
</style>
